const CookieNames = {
  SHOW_DISCOVERY_ON_UNSUPPORTED_RESOLUTION:
    "SHOW_DISCOVERY_ON_UNSUPPORTED_RESOLUTION",
  GUEST_ID: "GUEST_ID"
};

export default CookieNames;
